const queryConfig = {
    retry: 1,
}

export default queryConfig;
